<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>
									<template v-if="isRecommendPage">
										อสังหาริมทรัพย์แนะนำ
									</template>
									<template v-else-if="isLatestPage">
										อสังหาริมทรัพย์มาใหม่
									</template>
									<template v-else-if="isResidentPage">
										รวมที่อยู่อาศัย
									</template>
									<template v-else>
										อสังหาริมทรัพย์{{ $route.query.tx === 'RENT' ? 'เช่า' : 'ขาย' }}
									</template>
								</span>
								<template v-if="marketSelected">
									<v-divider
										class="mx-2 mt-3"
										style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
									/>
									<span style="overflow: hidden; text-overflow: ellipsis;">{{ marketSelected }}</span>
								</template>
								<template v-if="isResidentPage">
									<v-divider
										class="mx-2 mt-3"
										style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
									/>
									<span
										v-if="$route.path === '/value'"
										style="overflow: hidden; text-overflow: ellipsis;"
									>
										<!-- บ้านคุ้มค่า -->
										ที่อยู่อาศัย 1-3 ล้านบาท
									</span>
									<span
										v-if="$route.path === '/promising'"
										style="overflow: hidden; text-overflow: ellipsis;"
									>
										<!-- บ้านดีมีอนาคต -->
										ที่อยู่อาศัย 3-5 ล้านบาท
									</span>
									<span
										v-if="$route.path === '/luxury'"
										style="overflow: hidden; text-overflow: ellipsis;"
									>
										<!-- บ้านหรูเหนือระดับ -->
										ที่อยู่อาศัย 5 ล้านขึ้นไป
									</span>
									<span
										v-if="$route.path === '/commercial'"
										style="overflow: hidden; text-overflow: ellipsis;"
									>
										<!-- บ้านสร้างเงิน -->
										เชิงพาณิชย์
									</span>
									<span
										v-if="$route.path === '/home-condo'"
										style="overflow: hidden; text-overflow: ellipsis;"
									>
										คอนโด
									</span>
									<span
										v-if="$route.path === '/land'"
										style="overflow: hidden; text-overflow: ellipsis;"
									>
										ที่ดิน
									</span>
								</template>
							</div>
							<div
								class="search-filter"
							>
								<h1 v-if="isRecommendPage">
									อสังหาริมทรัพย์แนะนำ
								</h1>
								<h1 v-else-if="isLatestPage">
									อสังหาริมทรัพย์มาใหม่
								</h1>
								<h1 v-else-if="isResidentPage">
									รวมที่อยู่อาศัย
								</h1>
								<h1 v-else>
									อสังหาริมทรัพย์{{ $route.query.tx === 'RENT' ? 'เช่า' : 'ขาย' }}
								</h1>

								<div
									v-if="isResidentPage"
									class="pl-3 pr-5"
								>
									<h2 v-if="$route.path === '/value'">
										<!-- บ้านคุ้มค่า -->
										ที่อยู่อาศัย 1-3 ล้านบาท
									</h2>
									<h2 v-else-if="$route.path === '/promising'">
										<!-- บ้านดีมีอนาคต -->
										ที่อยู่อาศัย 3-5 ล้านบาท
									</h2>
									<h2 v-else-if="$route.path === '/luxury'">
										<!-- บ้านหรูเหนือระดับ -->
										ที่อยู่อาศัย 5 ล้านขึ้นไป
									</h2>
									<h2 v-else-if="$route.path === '/commercial'">
										<!-- บ้านสร้างเงิน -->
										เชิงพาณิชย์
									</h2>
									<h2 v-else-if="$route.path === '/home-condo'">
										อาคารชุด
									</h2>
									<h2 v-else-if="$route.path === '/land'">
										ที่ดิน
									</h2>
								</div>
								<div
									v-else
									class="pl-3 pr-5"
								>
									<h2>{{ marketSelected }}</h2>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<v-container
					v-if="isResidentPage"
					class="pa-0"
				>
					<v-row
						class="justify-center"
						no-gutters
					>
						<v-col xl="9">
							<z-img
								:storage="bannerImg"
								height="300"
								class="left"
								style="position: absolute; width: 100%;"
							/>
						</v-col>
					</v-row>
				</v-container>

				<z-img
					v-else
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/>
			</div>
		</div>

		<searchForm
			ref="searchComponent"
			class="float-tab"
			:tabs="isRecommendPage || isLatestPage || isResidentPage ? [{label: 'ค้นหาอสังหาริมทรัพย์', value: 0}] : null"
			:hide-text-search="isRecommendPage || isLatestPage || isResidentPage"
			:params="$route.query"
		/>

		<div
			v-if="isResidentPage"
			class="bg-red-red"
		>
			<v-container class="pa-0">
				<v-row
					class="property-recommend justify-center"
					no-gutters
				>
					<!-- <v-col md="1" /> -->
					<v-col xl="8">
						<h2 class="text-center my-7">
							แนะนำ<span class="red--text">อสังหาริมทรัพย์ใหม่</span>
						</h2>

						<propertyCarousel
							white
							:query="residentCarouselQuery"
							style="margin-bottom: 60px;"
						/>
					</v-col>
					<!-- <v-col md="1" /> -->
				</v-row>
			</v-container>
		</div>

		<div class="pb-6">
			<v-container class="pa-6">
				<v-row no-gutters>
					<v-col
						ref="top"
						xl="8"
						class="mx-auto"
					>
						<!-- <v-row>
							<v-col cols="12"> -->
						<div
							v-if="empty"
							class="text-center display-3"
						>
							<br><br>
							ไม่พบข้อมูล
							<br><br><br>
						</div>
						<v-row v-else>
							<v-col
								cols="12"
								class="pt-6 pb-4 text-center"
							>
								<h2>อสังหาริมทรัพย์</h2>
								<span class="red--text">{{ queryTxt }}</span>
							</v-col>

							<!-- Search page -->
							<v-col
								v-if="isSearchPage"
								cols="12"
							>
								<v-select
									v-model="orderBySelected"
									solo
									append-icon=""
									height="35"
									class="mx-auto"
									:class="isMobile ? 'sortLeft' : ''"
									:menu-props="{ offsetY: true, closeOnContentClick: true }"
									:items="orderBy"
									label=" จัดเรียงตาม"
									prepend-inner-icon="mdi-sort"
									style="width: max-content;"
									:on-click="`fbq('track', 'Search.Button.OrderBy'); _lt('send', 'Search.Button.OrderBy', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
								>
									<template v-slot:prepend-item>
										<v-list-item
											ripple
											@click="orderBySelected = null"
										>
											<v-list-item-content>
												<v-list-item-title>ค่าเริ่มต้น</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-divider class="mt-2" />
									</template>
								</v-select>

								<!-- <v-btn
									elevation="2"
									class="d-none d-md-flex ml-2"
									style="border-radius: 4px;"
									icon
									tile
									@click="grid = !grid"
								>
									<v-icon>{{ grid ? 'mdi-view-list' : 'mdi-view-grid' }}</v-icon>
								</v-btn>

								<v-btn
									elevation="2"
									class="sortRight d-md-none btnMSearch"
									:on-click="`fbq('track', 'Search.Button.FilterBy'); _lt('send', 'Search.Button.FilterBy', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
									@click="searchToggle"
								>
									<v-icon>mdi-filter-variant-plus</v-icon>
									เลือกตัวกรอง
								</v-btn> -->
							</v-col>

							<v-col
								v-for="(prop, i) in loading ? parseInt(perPage) : propertyList"
								:key="prop.id || i"
								cols="12"
								sm="6"
								md="4"
								lg="3"
							>
								<propertyListItemSkeleton v-if="loading" />
								<propertyListItem
									v-else
									:id="prop.id"
									:xs="grid"
								/>
							</v-col>

							<v-col
								v-if="!isFavoritePage"
								cols="12"
								class="px-0 px-md-3"
							>
								<div class="d-flex justify-center justify-md-space-between align-center mx-n3 px-md-3 text-center">
									<div
										class="d-none d-md-block"
										style="white-space: nowrap;"
									>
										<span class="red--text">{{ totalItem }}</span> รายการ
									</div>
									<v-pagination
										v-model="page"
										:length="totalPage"
										:total-visible="10"
									/>
								</div>
							</v-col>
						</v-row>
						<!-- </v-col>
						</v-row> -->
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'search'

import { mapActions, mapGetters, mapMutations } from 'vuex'

import searchForm from '~/components/2.0/search-form-home'
import propertyCarousel from '~/components/2.0/property-carousel'
import propertyListItem from '~/components/2.0/property-list-item'
import propertyListItemSkeleton from '~/components/2.0/property-list-item-skeleton'

export default {
	// scrollToTop: true,
	name: 'LIST',
	layout: 'default_2',

	components: {
		searchForm,
		propertyCarousel,
		propertyListItem,
		propertyListItemSkeleton
	},

	async fetch(context) {
		let data = {
			doc,
			fullPath: context.route.fullPath
		}
		await context.store.dispatch('page/initial', data)
	},

	data:() => ({
		keepAliveActivated: false,
		loading: true,
		orderBySelected: null,
		orderBy: [
			{ value: 'min-price', text: 'ราคา (ต่ำ-สูง)' },
			{ value: 'max-price', text: 'ราคา (สูง-ต่ำ)' },
			{ value: 'latest-property', text: 'รหัสทรัพย์ (ใหม่-เก่า)' },
			{ value: 'oldest-property', text: 'รหัสทรัพย์ (เก่า-ใหม่)' }
		],
		empty: false,
		perPage: 24,
		propertyList: [],
		query: {},
		queryTxt: '',
		page: 1,
		total: 0,
		grid: true,

		seoInfo: null
	}),

	computed: {
		...mapGetters({
			isMobile: 'isMobile',
			getProperties: 'property/getPropertyId_list',
			favoriteList: 'property/favoriteList',
			getProperty: 'property/getProperty',
			head: 'page/head',
		}),

		isFavoritePage () {
			return this.$route.path === '/favorites'
		},
		isRecommendPage () {
			return this.$route.path === '/recommend'
		},
		isLatestPage () {
			return this.$route.path === '/latest'
		},
		isPromotionPage () {
			return this.$route.path === '/promotion'
		},
		isSearchPage () {
			return this.$route.path === '/search'
		},
		isResidentPage () {
			return ['/value', '/promising', '/luxury', '/commercial', '/home-condo', '/land'].includes(this.$route.path)
		},

		residentCarouselQuery () {
			if (this.$route.path === '/promising') {
				return {
					'path': 'latest',
					'tx': 'BUY',
					'market_selected': ['HOME', 'TOWNHOUSE', 'CONDO'],
					'minprice': 3000000,
					'maxprice': 5000000
				}
			} else if (this.$route.path === '/luxury') {
				return {
					'path': 'latest',
					'tx': 'BUY',
					'market_selected': ['HOME', 'TOWNHOUSE', 'CONDO'],
					'minprice': 5000000
				}
			} else if (this.$route.path === '/commercial') {
				return {
					'path': 'latest',
					'tx': 'BUY',
					'market_selected': ['FACTORY', 'COMMERCIAL_BUILDING', 'APARTMENT', 'OTHERS']
				}
			} else if (this.$route.path === '/home-condo') {
				return {
					'path': 'latest',
					'tx': 'BUY',
					'market_selected': ['CONDO']
				}
			} else if (this.$route.path === '/land') {
				return {
					'path': 'latest',
					'tx': 'BUY',
					'market_selected': ['LAND']
				}
			}

			return {
				'path': 'latest',
				'tx': 'BUY',
				'market_selected': ['HOME', 'TOWNHOUSE', 'CONDO'],
				'maxprice': 3000000
			}
		},

		bannerImg () {
			if (this.isRecommendPage || this.isLatestPage) {
				return '/images/2.0/recommend-banner.jpg'
			} else if (this.isResidentPage) {
				if (this.$route.path === '/value') {
					return '/images/2.0/value-banner.jpg'
				} else if (this.$route.path === '/promising') {
					return '/images/2.0/promising-banner.jpg'
				} else if (this.$route.path === '/luxury') {
					return '/images/2.0/luxury-banner.jpg'
				} else if (this.$route.path === '/commercial') {
					return '/images/2.0/commercial-banner.jpg'
				} else if (this.$route.path === '/home-condo') {
					return '/images/2.0/home-condo-banner.jpg'
				} else if (this.$route.path === '/land') {
					return '/images/2.0/land-banner.jpg'
				}

				// return '/images/2.0/resident-banner.jpg'
				return '/images/2.0/commercial-banner.jpg'
			}

			return '/images/2.0/list-banner.jpg'
		},

		pageBreadcrumb () {
			if (this.isFavoritePage) {
				return 'รายการโครงการของฉัน'
			} else if (this.isRecommendPage) {
				return 'รายการโครงการแนะนำ'
			} else if (this.isLatestPage) {
				return 'รายการโครงการมาใหม่'
			} else if (this.isPromotionPage) {
				return 'โปรโมชั่น 5 คุ้ม' // 'โปรโมชั่นพิเศษ'
			} else {
				return 'ผลการค้นหา'
			}
		},

		searchMap () {
			if(process.client) {
				let params = { ...this.$route.query }
				delete params['page']
				delete params['order']
				return this.$routerHelper.getPathByRouteNameWithQuery('map', params)
			}
			return '/'
		},

		totalPage () {
			return Math.ceil(this.total / this.perPage)
		},

		totalItem () {
			return new Intl.NumberFormat('th-TH', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this.total)
		},

		marketSelected () {
			if (this.$route.query.market) {
				if (this.$route.query.market === 'REST')
					return 'ที่อยู่อาศัย '
				else if (this.$route.query.market === 'COMMERCIAL')
					return 'ทรัพย์เชิงพาณิชย์ '
				else if (this.$route.query.market === 'HOME')
					return 'บ้าน ' // 'บ้านเดี่ยว '
				else if (this.$route.query.market === 'TOWNHOUSE')
					return 'ทาวน์เฮ้าส์ '
				else if (this.$route.query.market === 'CONDO')
					return 'คอนโด, เอื้ออาทร '
				else if (this.$route.query.market === 'LAND')
					return 'ที่ดิน '
				else if (this.$route.query.market === 'COMMERCIAL_BUILDING')
					return 'อาคารพาณิชย์ '
				else if (this.$route.query.market === 'FACTORY')
					return 'โรงงาน '
				else if (this.$route.query.market === 'APARTMENT')
					return 'อพาร์ทเม้นท์ '
				else if (this.$route.query.market === 'OTHERS')
					return 'ทรัพย์อื่นๆ '
			}

			const market_selected = typeof this.$route.query.market_selected === 'string' ?
				[this.$route.query.market_selected] : this.$route.query.market_selected
			let queryTxt = ''
			if (market_selected) {
				for (const i in market_selected) {
					if (i > 0) queryTxt += ', '
					if (market_selected[i] === 'HOME')
						queryTxt += 'บ้าน' // 'บ้านเดี่ยว'
					else if (market_selected[i] === 'TOWNHOUSE')
						queryTxt += 'ทาวน์เฮ้าส์'
					else if (market_selected[i] === 'CONDO')
						queryTxt += 'คอนโด, เอื้ออาทร'
					else if (market_selected[i] === 'LAND')
						queryTxt += 'ที่ดิน'
					else if (market_selected[i] === 'COMMERCIAL_BUILDING')
						queryTxt += 'อาคารพาณิชย์'
					else if (market_selected[i] === 'FACTORY')
						queryTxt += 'โรงงาน'
					else if (market_selected[i] === 'APARTMENT')
						queryTxt += 'อพาร์ทเม้นท์'
					else if (market_selected[i] === 'OTHERS')
						queryTxt += 'ทรัพย์อื่นๆ'
				}
			}

			return queryTxt
		}
	},

	watch: {
		favoriteList (newVal) {
			if (this.$route.path === '/favorites') {
				this.total = this.favoriteList.length
				this.getPropertyList(newVal).then(propsList => {
					this.propertyList = propsList
				})
			}
		},

		orderBySelected (newOrder) {
			let params = { ...this.query }
			if (newOrder !== params.order) {
				if (newOrder) {
					params['order'] = newOrder
				} else {
					delete params['order']
				}

				this.$router.push({
					query: params,
					path: this.$route.path
				})
			}
		},

		page (newPage) {
			// this.$refs.top.scrollIntoView({ /*behavior: 'smooth',*/ block: 'center' })
			this.$refs.top.scrollIntoView({ behavior: 'smooth', block: 'end' })

			let params = null
			// Need to extract or clone params obj
			params = {
				...this.query,
				page: newPage
			}

			this.$router.push({
				path: this.$route.path,
				query: params
			})//.catch(() => { })
		}
	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
			if (this.$route.path !== '/favorites') {
				this.query = this.$route.query
				if (this.isMobile) {
					// Init mobile search criteria
					if (this.$parent.$parent.$parent.$refs.mobileSearchComponent) {
						this.$parent.$parent.$parent.$refs.mobileSearchComponent.initCriteria({ ...this.query })
					}

					// Init mobile mini filter
					if (this.$parent.$parent.$parent.$refs.miniFilter) {
						this.$parent.$parent.$parent.$refs.miniFilter.initCriteria({ ...this.query })
					}
				}
			}
		} else if (this.keepAliveActivated && this.$route.path !== '/favorites') {
			if (!this.$route.query.order) {
				this.orderBySelected = null
			}
			this.query = this.$route.query
			this.search()
		} else if (this.keepAliveActivated && this.$route.path === '/favorites') {
			this.total = this.favoriteList.length
			this.getPropertyList(this.favoriteList).then(propsList => {
				this.propertyList = propsList
			})
			this.loading = false
		}
	},

	// In case of search criteria change, just let component react to the new data (no need to re-render component)
	beforeRouteUpdate (to, from, next) {
		if (process.client && from.path === to.path) {
			if (window.windowNavigate) {
				window.windowNavigate = false
				if (this.$route.path !== '/favorites') {
					this.query = this.$route.query
					if (this.isMobile && this.$parent.$parent.$parent.$refs.mobileSearchComponent) {
						this.$parent.$parent.$parent.$refs.mobileSearchComponent.initCriteria({ ...this.query })
					}
				}
			} else {
				// window.scrollTo(0, 0)
				this.$refs.topPage.scrollIntoView({ behavior: 'smooth', block: 'end' })
				this.query = to.query
				this.search(true)
			}
			next()

			// this.$gtm.push({
			// 	event: 'property.search',
			// 	...this.query,
			// 	gtm: {
			// 		elementUrl: window.location.origin + to.fullPath
			// 	}
			// })

			// Navigate back effect after 'beforeRouteUpdate'
			setTimeout(() => {
				if (window.windowNavigate) {
					window.windowNavigate = false
					if (this.$route.path !== '/favorites') {
						this.query = this.$route.query
						if (this.isMobile && this.$parent.$parent.$parent.$refs.mobileSearchComponent) {
							this.$parent.$parent.$parent.$refs.mobileSearchComponent.initCriteria({ ...this.query })
						}
					}
				}
			}, 1500)
		} else {
			next()
		}
	},

	created() {
		if (process.client) {
			this.query = this.$route.query
			if (this.$route.path !== '/favorites') {
				this.search()
			}
		}
	},

	mounted() {
		if (this.$route.path === '/favorites') {
			this.total = this.favoriteList.length
			this.getPropertyList(this.favoriteList).then(propsList => {
				this.propertyList = propsList
			})
			this.loading = false
		}
		if (this.$route.query.order) {
			this.orderBySelected = this.$route.query.order
		}
	},

	methods: {
		...mapActions({
			getPropertyList: 'property/getPropertyList',
			searchProperty: 'property/searchProperty'
		}),
		...mapMutations({
			searchToggle: 'page/searchToggle'
		}),

		search (scroll = false) {
			this.loading = true
			this.propertyList = []
			this.total = 0
			// Call to store action for search with query (GET parameter)
			let params = { ...this.query }
			if (this.isRecommendPage) {
				params['path'] = 'recommend'
			} else if (this.isLatestPage) {
				params['path'] = 'latest'
			} else if (this.isPromotionPage) {
				params['promotion'] = 'static'
				params['order'] = 'province-category-specific'
			}

			if (this.$route.path === '/value') {
				params['tx'] = 'BUY'
				params['market_selected'] = ['HOME', 'TOWNHOUSE', 'CONDO']
				params['maxprice'] = 3000000
			} else if (this.$route.path === '/promising') {
				params['tx'] = 'BUY'
				params['market_selected'] = ['HOME', 'TOWNHOUSE', 'CONDO']
				params['minprice'] = 3000000
				params['maxprice'] = 5000000 // 10000000
			} else if (this.$route.path === '/luxury') {
				params['tx'] = 'BUY'
				params['market_selected'] = ['HOME', 'TOWNHOUSE', 'CONDO']
				params['minprice'] = 5000000 // 10000000
			} else if (this.$route.path === '/commercial') {
				params['tx'] = 'BUY'
				params['market_selected'] = ['FACTORY', 'COMMERCIAL_BUILDING', 'APARTMENT', 'OTHERS']
			} else if (this.$route.path === '/home-condo') {
				params['tx'] = 'BUY'
				params['market_selected'] = ['CONDO']
			} else if (this.$route.path === '/land') {
				params['tx'] = 'BUY'
				params['market_selected'] = ['LAND']
			}

			if (scroll) {
				this.$nextTick(() => {
					// window.scrollTo(0, 0)
					setTimeout(() => {
						this.$refs.top.scrollIntoView({ behavior: 'smooth', block: 'start' })
					}, 0)
				})
			}

			this.searchProperty(params).then(propObj => {
				this.propertyList = propObj.propsList
				this.total = propObj.total
				this.queryTxt = propObj.queryTxt
				this.perPage = propObj.perPage

				this.empty = this.propertyList.length === 0
				this.page = parseInt(this.query.page) || 1
				this.loading = false
				this.keepAliveActivated = true
			})
		}
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 100px;
		z-index: 2;

		div {
			border-left: solid 4px #c20000;
		}
	}
}
.float-tab {
	margin-top: -52px;

	&::v-deep .v-item-group.v-btn-toggle {
		background: transparent;

		button {
			opacity: unset;
		}
	}
}
.bg-red-red {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgb(255,255,255);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%,rgba(157,30,37,1) 60%, rgba(255,255,255,1) 60%, rgba(255,255,255,1) 100%);
	}
}
.property-recommend > div {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		background: rgb(237,28,36);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%, rgba(157,30,37,1) 60%, rgba(237,28,36,1) 60%, rgba(237,28,36,1) 100%);
		position: absolute;
		width: 16%;
		left: -8%;
		top: 0;
		bottom: 0;
	}
}
.v-pagination ::v-deep {
	position: relative;

	li {
		button {
			border-radius: unset;
			box-shadow: unset;
			height: 34px;
		}

		&:first-child, &:last-child {
			position: absolute;
			right: 0;

			button {
				background-color: #3a3a3a;
				margin: 0;

				// @media (min-width: 600px) {
				// 	margin: auto 10px;
				// }

				i {
					color: #fff;
				}
			}
		}
		&:first-child {
			left: 0;
			right: unset;

			@media (min-width: 960px) {
				right: 34px;
				left: unset;
			}
		}
		&:nth-child(2) {
			@media (min-width: 960px) {
				margin-left: -90px;
			}
		}
	}
}
</style>
